import React from 'react';
import useMedia from 'use-media';

export const BlueShade = ({ className }) => {
  const isTablet = useMedia({ minWidth: '768px' });
  const isDesktop = useMedia({ minWidth: '1024px' });
  const isWide = useMedia({ minWidth: '1280px' });

  let width = 400;
  if (isTablet) width = 825;
  if (isDesktop) width = 1150;
  if (isWide) width = 1700;

  return (
    <svg
      width={width}
      viewBox="0 0 1440 2778"
      fill="none"
      className={className}
      style={{ left: 0, bottom: isWide ? -569 : isDesktop ? -200 : 350, zIndex: -1 }}>
      <path
        d="M1988 0L-59.0718 2047.51C-60.9467 2049.38 -62 2051.93 -62 2054.58V2498.86C-62 2507.77 -51.2275 2512.23 -44.9282 2505.93L1985.07 475.498C1986.95 473.623 1988 471.08 1988 468.428V0Z"
        fill="url(#blue_shade)"
      />
      <path
        d="M276.585 1782.42L-165.415 2224.85C-165.79 2225.22 -166 2225.73 -166 2226.26V2693.17C-166 2694.95 -163.845 2695.84 -162.585 2694.58L279.415 2252.15C279.79 2251.78 280 2251.27 280 2250.74V1783.83C280 1782.05 277.845 1781.16 276.585 1782.42Z"
        fill="#EBF8FF"
        stroke="#2A4365"
        strokeWidth="8"
      />
      <path
        d="M276.585 1860.42L-165.415 2302.85C-165.79 2303.22 -166 2303.73 -166 2304.26V2771.17C-166 2772.95 -163.845 2773.84 -162.585 2772.58L279.415 2330.15C279.79 2329.78 280 2329.27 280 2328.74V1861.83C280 1860.05 277.845 1859.16 276.585 1860.42Z"
        fill="#EBF8FF"
        stroke="#2A4365"
        strokeWidth="8"
      />
      <path
        d="M164 2127C164 2126.45 163.552 2126 163 2126H133C132.448 2126 132 2126.45 132 2127V2169C132 2169.55 131.552 2170 131 2170H89C88.4477 2170 88 2170.45 88 2171V2201C88 2201.55 88.4477 2202 89 2202H131C131.552 2202 132 2202.45 132 2203V2245C132 2245.55 132.448 2246 133 2246H163C163.552 2246 164 2245.55 164 2245V2203C164 2202.45 164.448 2202 165 2202H207C207.552 2202 208 2201.55 208 2201V2171C208 2170.45 207.552 2170 207 2170H165C164.448 2170 164 2169.55 164 2169V2127Z"
        fill="white"
        stroke="#2A4365"
        strokeWidth="8"
      />
      <defs>
        <linearGradient
          id="blue_shade"
          x1="1440.5"
          y1="778.499"
          x2="-12.5016"
          y2="2231.5"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="white" stopOpacity="0.34" />
          <stop offset="1" stopColor="#EBF8FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
